import React, { useState, useEffect } from 'react';
import { Card, Table, FormControl } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Layout from '../../layout/default';
import Block from '../../components/Block/Block';
import instance from "../api";
import ReactPaginate from 'react-paginate';

const CountryDetails = () => {
    const { country_id } = useParams();
    const [regions, setRegions] = useState([]);
    const [taxData, setTaxData] = useState({});
    const [countryName, setCountryName] = useState('');

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const fetchData = async () => {
        try {
            const response = await instance.get(`api/TaxSetting/${country_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                    'ngrok-skip-browser-warning': 'true',
                }
            });
            setRegions(response.data.rows);
            if (response.data.rows.length > 0) {
                setCountryName(response.data.rows[0].WebtagCountry.name);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [country_id]);

    const handleTaxChange = (tax_id, value) => {
        setTaxData((prevData) => ({
            ...prevData,
            [tax_id]: { ...prevData[tax_id], tax_value: value },
        }));
    };

    const handleTaxNameChange = (tax_id, value) => {
        setTaxData((prevData) => ({
            ...prevData,
            [tax_id]: { ...prevData[tax_id], tax_name: value },
        }));
    };

    const updateTaxSetting = async (tax_id) => {
        const taxDetails = taxData[tax_id];
        if (taxDetails) {
            try {
                await instance.put(`api/TaxSetting/update/${tax_id}`, {
                    tax_name: taxDetails.tax_name,
                    tax_value: taxDetails.tax_value,
                });
            } catch (error) {
                console.error('Error updating tax setting:', error);
            }
        }
    };

    const handleBlur = (tax_id) => {
        if (taxData[tax_id]) {
            updateTaxSetting(tax_id);
        }
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const displayRegions = regions.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <Layout title="Country Details" content="container">
            <Block.Head>
                <Block.HeadBetween>
                    <Block.HeadContent>
                    <Block.Title tag="h2">{countryName}-Regions</Block.Title>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>

            <Block>
                <Card>
                    <div className="p-3">
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>Region Name</th>
                                    <th>Tax Percentage</th>
                                    <th>Tax Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayRegions.map((region) => (
                                    <tr key={region.tax_id}>
                                        <td>{region.WebtagZone.name}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <FormControl
                                                    type="text"
                                                    value={taxData[region.tax_id]?.tax_value || region.tax_value}
                                                    onChange={(e) => handleTaxChange(region.tax_id, e.target.value)}
                                                    onBlur={() => handleBlur(region.tax_id)}
                                                    className="me-2"
                                                    style={{ maxWidth: '80px' }}
                                                />
                                                <span>%</span>
                                            </div>
                                        </td>
                                        <td>
                                            <FormControl
                                                type="text"
                                                value={taxData[region.tax_id]?.tax_name || region.tax_name}
                                                onChange={(e) => handleTaxNameChange(region.tax_id, e.target.value)}
                                                onBlur={() => handleBlur(region.tax_id)}
                                                className="me-2"
                                                style={{ maxWidth: '100px' }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <ReactPaginate
                                previousLabel={'<'}
                                nextLabel={'>'}
                                breakLabel={'...'}
                                pageCount={Math.ceil(regions.length / itemsPerPage)}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                            />
                            <div className="pagination-summary">
                                {`Showing ${currentPage * itemsPerPage + 1} to ${Math.min((currentPage + 1) * itemsPerPage, regions.length)} of ${regions.length} entries`}
                            </div>
                        </div>
                    </div>
                </Card>
            </Block>
        </Layout>
    );
};

export default CountryDetails;
